
export const getReportes = (tipo_filtro, filtro) => {
    return async (dispatch) => {
        dispatch({type: "DOWNLOAD_FILE_LOADING"});
        let headers = {
            "Content-Type": "application/x-www-form-urlencoded"
        };
        if(!!localStorage.getItem('token_cafe')){
            headers["Authorization"] = `Bearer ${localStorage.getItem('token_cafe')}`;

            let a = await fetch(`${process.env.REACT_APP_API_URL}/reportes/cultivo?${tipo_filtro}=${filtro}`, { headers, method: 'GET' });
            let b = await a.blob();
            if(!!b){
                dispatch({type:"DOWNLOAD_FILE_SUCCESS", data: b});
            }else{
                dispatch({type:"DOWNLOAD_FILE_FAILED", data: 'No ha sido posible generar el archivo. Inténtelo de nuevo.'});
            }
        }else{
            dispatch({type: "DOWNLOAD_FILE_FAILED", data: 'Ha ocurrido un error en la carga de datos.'});
        }
    }
};

export const getInitialProps = () => {
    return (dispatch) => {
        dispatch({type: "INITIAL_DATA"});

    }
};

